export enum NavigationItemAction {
  ToggleSwitchableAccountsMenu = 'toggleSwitchableAccountsMenu',
  ToggleAccountMenu = 'toggleAccountMenu',
  ToggleShowMoreMenu = 'toggleShowMoreMenu'
}
